/**
 * Created by Administrator on 2017/10/31.
 */
import {Validator} from 'vee-validate'

Validator.extend('certigryNo', {
  messages: {
    zh_CN:field => '请输入正确格式的身份证号码'
  },
  validate: value => {
    return /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(value);
  }
});

Validator.extend('password', {
  messages: {
    zh_CN:field => '请输入8-16位字母和数字组合'
  },
  validate: value => {
    return /(^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$)/.test(value);
  }
});

Validator.extend('fixPhone', {
  messages: {
    zh_CN:field => '固话格式需为01055556666'
  },
  validate: value => {
    return /^[0-9_]{11}$/.test(value);
  }
});


export default {
  validator:new Validator({
    email:'email|max:50',
    necc: 'required',
    userName: 'required',
    password: 'required|password',
    verifyCode: 'required|min:4|max:4',
    phone:'required|digits:11',
    phoneVerifyCode:'required',
    name:'required|max:50',
    sex:'selectRequire',
    certigy:'selectRequire',
    fixPhone:'fixPhone',
    certigyNo:'required|max:20|certigryNo',
    nowLive:'required',
    nowLiveAddress:'required|max:100',
    pswLong:'required|max:12|min:6|alpha_num',
    aginPsw:'required|max:12|min:6|alpha_num',
    perNum:'required|between:1,999999|regex:^([1-9][0-9]*)$',
    max50R:'required|max:50',
    max50:'max:50'
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/validitors.js